/*
 * Copyright (c) 2025 AirAsia Berhad (Malaysia). All rights reserved.
 *
 * This software is proprietary and confidential. Unauthorized copying of this file,
 * via any medium, is strictly prohibited. Do not distribute, copy, modify, or reuse
 * any part of this code without explicit written permission from AirAsia Move.
 *
 * For internal use only.
 */

import { useDeviceInfo } from '@airasia-rn/ui';
import { FC, useState, useEffect } from 'react';
import { ProductTilesData } from '../../models/homepageBlockTypes';
import ProductTilesMobileView from '../ProductTilesMobileView/ProductTilesMobileView';
import ProductTilesWebView from '../ProductTilesWebView/ProductTilesWebView';

export interface ProductTilesViewProps {
  productTilesData: ProductTilesData;
  onProductTileClicked: (redirectionUrl: string, productId: string) => void;
  onDataLoaded?: () => void;
  imageReloadKey?: number;
}

function ProductTilesView({
  productTilesData,
  onProductTileClicked,
  onDataLoaded,
  imageReloadKey,
}: ProductTilesViewProps) {
  const { isMobileWidth } = useDeviceInfo();
  const [showAllTiles, setShowAllTiles] = useState(false);

  useEffect(() => {
    if (onDataLoaded) {
      onDataLoaded();
    }
  }, [onDataLoaded]);

  if (isMobileWidth) {
    return (
      <ProductTilesMobileView
        productTilesData={productTilesData}
        onProductTileClicked={onProductTileClicked}
        imageReloadKey={imageReloadKey}
      />
    );
  }

  return (
    <ProductTilesWebView
      productTilesData={productTilesData}
      onProductTileClicked={onProductTileClicked}
      showAllTiles={showAllTiles}
      setShowAllTiles={setShowAllTiles}
    />
  );
}

export default ProductTilesView;
